export default __webpack_public_path__ + "static/media/AlertVector.2ee59952.svg";